import { BaseDto } from './base.dto';

export class UserRoleMerchantDto extends BaseDto {
  merchantId: number;
  userId: number;
  read: boolean;
  write: boolean;
}
